import { useContext } from "react"
import { Outlet } from "react-router";
import NoPermission from "../components/ui/NoPermission";
import { AuthContext } from "../contexts/authContext";
import LecturerSidebar from "../pages/Lecturer/components/LecturerSidebar";
import { AnalyticsProvider } from "../contexts/AnalyticsContext";

function LecturerLayout() {
  const { user } = useContext(AuthContext);

  return (
    user?.user_type == "lecturer" ?
      <AnalyticsProvider>
        <LecturerSidebar>
          <Outlet />
        </LecturerSidebar>
      </AnalyticsProvider>
      :
      <NoPermission />
  )
}

export default LecturerLayout